export default {"src":"/_next/static/media/butter.cbe566a7.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};